export * from './IconAlignBlocksRight';
